<template>
  <div class="tab-content params-setting-root">
    <div>
      <el-table :data="tableData">
        <el-table-column type="index" label="序号" width="55">
        </el-table-column>
        <el-table-column prop="type" label="类型" width="120" />
        <el-table-column prop="parameterContent" label="参数内容" width="180" />
        <el-table-column label="参数值" width="180">
          <template slot-scope="scope">
            <div class="row">
              <el-input
                size="small"
                v-model="scope.row.parameterValue"
                maxlength="10"
                oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')"
                style="width: 120px;"
              />
              <span class="unit">{{ scope.row.parameterUnit }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="parameterDescription" label="参数说明" />
      </el-table>
    </div>
    <div class="bottom-btn">
      <el-button class="fix-four" type="primary" @click="updataParamsInfo"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { getPareamsInfo, updataPareamsInfo } from "@/api/platform/index.js";

export default {
  data() {
    return {
      /**
       * {
    "id": "1",
    "type": "【结算】",
    "parameterContent": "待付款订单自动取消时长",
    "parameterValue": "123",
    "parameterUnit": "时",
    "parameterDescription": "待付款订单超过 XX 小时后将自动取消",
    "delFlag": 0
}
       */
      tableData: [],
    };
  },
  created() {
    this.doLoadParamsInfo();
  },
  methods: {
    doLoadParamsInfo() {
      getPareamsInfo().then((data) => {
        if (data instanceof Array && data.length > 0) {
          // 移除 id === 3 的数据
          data = data.filter((item) => item.id!== "3");
          this.tableData = data;
        }
      });
    },
    updataParamsInfo() {
      const data = _.cloneDeep(this.tableData);
      updataPareamsInfo(data).then((data) => {
        this.$message.success("保存成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.params-setting-root {
  .row {
    display: flex;
    align-items: center;

    .unit {
      margin-left: 4px;
    }
  }
}
</style>
